import React, { useState, useRef, useEffect } from "react";
import { useI18n } from "@/i18n";
import { Check } from "lucide-react";

export const LanguageSwitcher = () => {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const current = languages.find((l) => l.code === lang) || languages[0];
  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="lang-switcher"
        aria-label="Language"
        title={current.label}
        className="w-10 h-10 grid place-items-center rounded-sm border border-white/15 text-zinc-300 hover:border-aurora-cyan/50 hover:text-aurora-cyan transition-colors"
      >
        <img src={`https://flagcdn.com/${current.cc}.svg`} alt={current.label} className="w-6 h-[15px] object-cover rounded-[2px] shadow-sm" loading="lazy" />
      </button>
      {open && (
        <div
          data-testid="lang-menu"
          className="absolute end-0 mt-2 w-44 popover-solid rounded-md py-1 z-[80] max-h-[min(70vh,360px)] overflow-y-auto"
          style={{ insetInlineEnd: 0 }}
        >
          {languages.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm hover:bg-white/5 transition-colors ${l.code === lang ? "text-aurora-cyan" : "text-zinc-300"}`}
            >
              <img src={`https://flagcdn.com/${l.cc}.svg`} alt={l.label} className="w-6 h-[15px] object-cover rounded-[2px] shadow-sm shrink-0" loading="lazy" />
              <span className="flex-1 text-start">{l.label}</span>
              {l.code === lang && <Check className="w-3.5 h-3.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
